import { inject, Injectable, signal } from '@angular/core';
import {
  IAllowGlimpseResponse,
  IComment,
  ICommentResponse,
  IIclData,
  IReactionsResponse,
  IStory,
  IStoryPayload
} from './story';
import { HttpUtils } from 'app/shared/http-utils';
import { Observable, of, tap } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { StoryFilterService } from './story-filter.service';
import { GetListPayload } from 'app/shared/models/get-list-payload';
import { StoryStatus } from './story-status';
import { DialogService } from 'app/shared/dialog/dialog.service';
import { StoryFormComponent } from './story-form/story-form.component';
import { IPreviewUrls } from 'app/shared/form/file.model';
import { FacetCrudService } from 'app/my-history/shared/facet-crud.service';
import { FacetFilterService } from 'app/my-history/facet/facet-filter.service';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root',
})
export class StoryService extends FacetCrudService<IStory> {
  override apiUrl: string = HttpUtils.getApiUrl('/story/v1/stories');
  override entityName: string = 'story';

  public commentsApiUrl: string = HttpUtils.getApiUrl('/comments/v1');
  public allowGlimpseUrl: string = HttpUtils.getApiUrl('/story/v1/shared/');

  private facetFilter = inject(FacetFilterService);
  private storyFilter = inject(StoryFilterService);
  private dialogService = inject(DialogService);

  mentionsToAdd = signal(new Set<number>());
  mentionsToRemove = signal(new Set<number>());
  acl = signal<IIclData | null>(null);
  stories = signal<IStory[]>([]);
  draftStories = signal<IStory[]>([]);
  storiesTotal = signal<number | null>(null);
  draftStoriesTotal = signal<number | null>(null);

  setAcl(acl: IIclData) {
    this.acl.set(acl);
  }

  setMentionsToRemove(mentionsToRemove: Set<number>) {
    this.mentionsToRemove.set(mentionsToRemove);
  }

  setMentionsToAdd(mentionsToAdd: Set<number>) {
    this.mentionsToAdd.set(mentionsToAdd);
  }

  override setSelected(id: string | null): Observable<IStory | null> {
    if (!id) {
      this.selectedFacetSignal.set(null);
      return of(null);
    }

    return this.getById(id).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((facet) => this.selectedFacetSignal.set(facet)),
    );
  }

  openStory() {
    const dialogRef = this.dialogService.open(StoryFormComponent, {
      maxWidth: 900,
      width: '900px',
    });

    return dialogRef.afterClosed().pipe(
      tap((result) => {
        this.setSelected(result.id);
      }),
    );
  }

  getStoryImages(story: IStory | undefined): IPreviewUrls[] {
    if (story && story.images && story.images.data) {
      return story.images.data.map((image) => {
        return {
          name: image.fileName,
          url: image.url,
        };
      });
    }

    return [];
  }

  // getPublishedStories(payload: GetListPayload = {}, isTotal = false) {
  //   const {
  //     take = 50,
  //     status = 'publish',
  //     includedLenses = this.storyFilter.includedLenses(),
  //   } = payload;
  //   const start = this.facetFilter.startDate();
  //   const end = this.facetFilter.endDate();
  //   const selectedFacetId = this.storyFilter.selectedFacet()?.id;
  //   const paramsTotal = new HttpParams().set('take', 1).set('status', status);
  //   let params = new HttpParams()
  //     .set('take', take) // TODO infinity scroll
  //     .set('asc', false)
  //     .set('order', 'end')
  //     .set('status', status);
  //
  //   if (this.facetFilter.isFilteredByDates()) {
  //     params = params.set('end', end).set('start', start);
  //   }
  //   if (includedLenses && includedLenses !== 1) {
  //     params = params.set('includedLenses', includedLenses);
  //   }
  //   if (selectedFacetId) {
  //     params = params.set('unitId', selectedFacetId);
  //   }
  //
  //   return super.getAll(isTotal ? paramsTotal : params).pipe(
  //     tap((res) => {
  //       if (isTotal) {
  //         status === StoryStatus.publish ? this.storiesTotal.set(res.total) : null,
  //           status === StoryStatus.draft ? this.draftStoriesTotal.set(res.total) : null;
  //       } else {
  //         status === StoryStatus.publish ? this.stories.set(res.data) : null,
  //           status === StoryStatus.draft ? this.draftStories.set(res.data) : null;
  //       }
  //     }),
  //   );
  // }
  //
  // getDraftStories(payload: GetListPayload = {}, isTotal = false) {
  //   const {
  //     take = 50,
  //     status = 'draft',
  //     includedLenses = this.storyFilter.includedLenses(),
  //   } = payload;
  //   const start = this.facetFilter.startDate();
  //   const end = this.facetFilter.endDate();
  //   const selectedFacetId = this.storyFilter.selectedFacet()?.id;
  //   const paramsTotal = new HttpParams().set('take', 1).set('status', status);
  //   let params = new HttpParams()
  //     .set('take', take) // TODO infinity scroll
  //     .set('asc', true)
  //     .set('order', 'end')
  //     .set('status', status);
  //   if (this.facetFilter.isFilteredByDates()) {
  //     params = params.set('end', end).set('start', start);
  //   }
  //   if (includedLenses && includedLenses !== 1) {
  //     params = params.set('includedLenses', includedLenses);
  //   }
  //   if (selectedFacetId) {
  //     params = params.set('unitId', selectedFacetId);
  //   }
  //   return super.getAll(isTotal ? paramsTotal : params).pipe(
  //     tap((res) => {
  //       if (isTotal) {
  //         status === StoryStatus.publish ? this.storiesTotal.set(res.total) : null,
  //           status === StoryStatus.draft ? this.draftStoriesTotal.set(res.total) : null;
  //       } else {
  //         status === StoryStatus.publish ? this.stories.set(res.data) : null,
  //           status === StoryStatus.draft ? this.draftStories.set(res.data) : null;
  //       }
  //     }),
  //   );
  // }

  getAllStories(payload: GetListPayload = {}, isTotal = false) {
    const {
      take = 50,
      status = this.storyFilter.status(),
      includedLenses = this.storyFilter.includedLenses(),
    } = payload;
    const start = this.facetFilter.startDate();
    const end = this.facetFilter.endDate();
    const selectedFacetId = this.storyFilter.selectedFacet()?.id;
    const paramsTotal = new HttpParams().set('take', 1).set('status', status);
    let params = new HttpParams()
      .set('take', take) // TODO infinity scroll
      .set('asc', true)
      .set('order', 'start')
      .set('status', status);
    if (this.facetFilter.isFilteredByDates()) {
      params = params.set('end', end).set('start', start);
    }
    if (includedLenses && includedLenses !== 1) {
      params = params.set('includedLenses', includedLenses);
    }
    if (selectedFacetId) {
      params = params.set('unitId', selectedFacetId);
    }
    return super.getAll(isTotal ? paramsTotal : params).pipe(
      tap((res) => {
        if (isTotal) {
          status === StoryStatus.publish ? this.storiesTotal.set(res.total) : null,
            status === StoryStatus.draft ? this.draftStoriesTotal.set(res.total) : null;
        } else {
          status === StoryStatus.publish ? this.stories.set(res.data) : null,
            status === StoryStatus.draft ? this.draftStories.set(res.data) : null;
        }
      }),
    );
  }

  getStoriesTotal() {
    return this.getAllStories({ status: StoryStatus.publish }, true);
  }

  getDraftStoriesTotal() {
    return this.getAllStories({ status: StoryStatus.draft }, true);
  }

  reloadStories() {
    return this.getAllStories();
  }

  deleteStory(id: string) {
    return super.delete(id);
  }

  saveStory(story: IStoryPayload) {
    return super.save(story, story.id);
  }

  getStoriesData(): void {
    this.getAllStories().subscribe(() => {
      this.getStoriesTotal().subscribe();
      this.getDraftStoriesTotal().subscribe();
    });
  }

  getStoryById(storyId: string): Observable<IStory> {
    return this.http.get<IStory>(this.apiUrl + '/' + storyId);
  }

  removeImage(apiUrl: string, fileName: string, storyId: string) {
    return this.http.delete(apiUrl + '/' + storyId, {
      params: { fileName },
    });
  }

  removeMention(storyId: string, userId: number) {
    return this.http.delete(this.apiUrl + '/' + storyId + '/mentions/' + userId, {
      params: { userId },
    });
  }

  addMention(storyId: string, userId: number) {
    return this.http.post(this.apiUrl + '/' + storyId + '/mentions/' + userId, {
      userId,
    });
  }

  addMentionBatch(storyId: string, users: number[]) {
    return this.http.post(this.apiUrl + '/' + storyId + '/mentions/batch', {
      users,
    });
  }

  getStoryReactions(storyId: string): Observable<IReactionsResponse> {
    return this.http.get<IReactionsResponse>(this.apiUrl + '/' + storyId + '/reactions');
  }

  addStoryAcl(storyId: string, params: IIclData) {
    return this.http.post(this.apiUrl + '/' + storyId + '/acl', params);
  }

  addStoryReaction(storyId: string, reactionType: string = 'star') {
    return this.http.post(this.apiUrl + '/' + storyId + '/reactions/' + reactionType, {
      params: { storyId, reactionType },
    });
  }

  removeStoryReaction(storyId: string, reactionType: string = 'star') {
    return this.http.delete(this.apiUrl + '/' + storyId + '/reactions/' + reactionType);
  }

  createComment(story: { id: string; userId: number }, content: string): Observable<IComment> {
    return this.http.post<IComment>(this.commentsApiUrl, { story, content });
  }

  approveComment(commentId: string): Observable<IComment> {
    return this.http.put<IComment>(`${this.commentsApiUrl}/${commentId}/resolve`, {});
  }

  rejectComment(commentId: string): Observable<IComment> {
    return this.http.put<IComment>(`${this.commentsApiUrl}/${commentId}/reject`, {});
  }

  deleteComment(commentId: string) {
    return this.http.delete(this.commentsApiUrl + '/' + commentId);
  }

  allowGlimpse(storyId: string): Observable<IAllowGlimpseResponse> {
    return this.http.post<IAllowGlimpseResponse>(this.allowGlimpseUrl + storyId, { storyId });
  }

  getStoryForGuest(storyId: string, apiKey: string): Observable<IStory> {
    return this.http.get<IStory>(this.allowGlimpseUrl + storyId + '?key=' + apiKey);
  }

  getCommentsForStory(storyId: string, currentCount = 0, totalCount = 20): Observable<ICommentResponse> {
    const commentsPerRequest = 20;
    const params = new HttpParams().set('take', 20).set('skip', currentCount).set('asc', false);

    if (totalCount > currentCount) {
      params.set(
        'take',
        totalCount - currentCount > commentsPerRequest ? commentsPerRequest : totalCount - currentCount,
      );
    }

    return this.http.get<ICommentResponse>(this.commentsApiUrl + '/story/' + storyId, { params });
  }

  formatDate(story: IStory | IStoryPayload) {
    let formattedDate = '';
    if (story && story.dateComponents) {
      const date = story.dateComponents;
      if (story.dateComponents.year) {
        formattedDate = `${date.year}`;
      }
      if (story.dateComponents.month) {
        formattedDate = `${date.month}/${date.year}`;
      }

      if (story.dateComponents.day) {
        formattedDate = `${date?.month}/${date?.day}/${date.year}`;
      }
    }

    return formattedDate;
  }
}
